import HeroCallToActionSection from './HeroCallToActionSection'

interface MasterpieceSectionProps {
  backgroundImage?: string
}

const MasterpieceSection = ({ backgroundImage = "/Member Services/Your Life Our Masterpiece/bg.png" }: MasterpieceSectionProps) => {
  const encodedBackgroundImage = "/Landing Page/Your Life Our Masterpiece/bg.png";
  return (
    <HeroCallToActionSection
      title="Your Life, Our Masterpiece."
      content="Having pioneered and perfected the concept of luxury lifestyle management, we know one thing for certain: it's all about you. We've provided the world's most distinguished individuals access to industry-leading private concierge services – and now, it's your turn. If you want the best in life, come to the best in the business."
      buttonText="Become a Member"
      buttonLink="/membership-enquiry"
      backgroundImage={encodedBackgroundImage}
    />
  )
}

export default MasterpieceSection